export default __webpack_public_path__ + "static/media/Logo Kvision.5aab0ad5.png";